var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\r\n      短信通知："),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "smsFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.smsFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "smsFlag", $$v)
                },
                expression: "settingsConfig.smsFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，签约、审批等信息将通过短信通知您（若企业人脸识别授权列表中仅有法人，则将发送给法人，若人脸识别授权列表存在授权人，则将发送给默认授权人）。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\r\n      邮件通知：\r\n      "),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "emailFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.emailFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "emailFlag", $$v)
                },
                expression: "settingsConfig.emailFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，签约、审批等信息将通过邮件通知您（邮件将发送至企业账号对应的邮箱）。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\r\n      微信通知：\r\n      "),
            _c("el-switch", {
              attrs: {
                value: _vm.settingsConfig.wxFlag,
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.weChatSwitchChange($event, "wxFlag")
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.settingsConfig.wxName,
                    expression: "settingsConfig.wxName"
                  }
                ]
              },
              [
                _c("span", { staticClass: "bind-target" }, [
                  _vm._v("已绑定：" + _vm._s(_vm.settingsConfig.wxName))
                ]),
                _c(
                  "span",
                  {
                    staticClass: "unbind",
                    attrs: { slot: "reference" },
                    on: { click: _vm.unnindWx },
                    slot: "reference"
                  },
                  [_vm._v("解绑")]
                )
              ]
            )
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，签约、审批等信息将通过微信消息通知您（签署通知将发送至当前账号绑定的微信账号，一个账号仅能绑定一个微信）。"
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定微信",
            visible: _vm.bindWeChatVisi,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.bindWeChatVisi = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "qrcode-box" },
            [
              _c("qrcode", {
                key: "evidence",
                attrs: { value: _vm.bindWechatQR.url, size: 260, leave: "H" }
              }),
              _c("p", [_vm._v("使用手机微信扫码绑定")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.bindWeChatVisi = false
                    }
                  }
                },
                [_vm._v("关 闭")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("消息通知设置")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31f29b3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f29b3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/accountPage/components/mesNotifi.vue
// module id = Cs41
// module chunks = 0 28 167